import React from 'react'
import Helmet from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import { StaticImage } from "gatsby-plugin-image"
import Navbar from './Navbar'
import './blocks.css'
import './all.css'
import FooterForm from './FooterForm'
import parse from 'html-react-parser'



const TemplateWrapper = ({ children }) => {

  const data = useStaticQuery(graphql`
    query FooterContent {
      wp {
        zornsOptions {
          zOptions {
            info
            footerR1
            footerR2
            footerR3
          }
        }
      }
    }
  `)

  return (
    <React.Fragment>
      <Helmet title="Home | Zorn's of Bethpage" />
      <Navbar utilityNav={true} />
      {children}
      <footer>
        <div className="content-wrapper">

          <div className="columns">
            <div className="column">
              <a href='https://www.google.com/maps/dir//4321+Hempstead+Turnpike,+Bethpage,+NY+11714/@41.242202,-73.8580743,9z/data=!4m8!4m7!1m0!1m5!1m1!1s0x89c28008ac920d1d:0x76882d4ea56668de!2m2!1d-73.4774061!2d40.7264893'>
                <StaticImage alt="Zorn's Map" src="../images/map.jpg" className="map" width={350} height={306} />
              </a>
              
              <span id="social">             
              
                <a href="https://www.facebook.com/zornsbethpage/" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's Facebook" src="../images/zorns-social-icon-facebook.svg" className="social-icon" width={30} height={30} />
                </a>

                <a href="https://www.instagram.com/zornsofbethpage/" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's Instagram" src="../images/zorns-social-icon-instagram.svg" className="social-icon" width={30} height={30} />
                </a>

                <a href="https://www.linkedin.com/company/zorn%27s-of-bethpage" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's LinkedIn" src="../images/zorns-social-icon-linkedin.svg" className="social-icon" width={30} height={30} />
                </a>

                <a href="https://twitter.com/zornsofbethpage" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's Twitter" src="../images/zorns-social-icon-twitter.svg" className="social-icon" width={30} height={30} />
                </a>

                <a href="https://www.youtube.com/channel/UCjCwZnSolbOE2yhFy_Fxv6Q" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's YouTube" src="../images/zorns-social-icon-youtube.svg" className="social-icon" width={30} height={30} />
                </a>

                <a href="https://www.tiktok.com/@zornsofbethpage" target="_blank" rel="noreferrer">
                  <StaticImage alt="Zorn's YouTube" src="../images/zorns-social-icon-tik-tok.png" className="social-icon" width={30} height={30} />
                </a>
              </span>
            </div>

            

                
                    <div className="column">
                      <h2>Join our Z-mail</h2>   
                      <FooterForm></FooterForm>
                      {parse(data.wp.zornsOptions.zOptions.info)}
                    </div>
                    <div className='column'>
                      {parse(data.wp.zornsOptions.zOptions.footerR1)}
                      {parse(data.wp.zornsOptions.zOptions.footerR2)}
                      {parse(data.wp.zornsOptions.zOptions.footerR3)}
                    </div>
                 

            
          </div>
        </div>

        <div id="bar">
          © Copyright 2022 zornsofbethpage.com | All Rights Reserved
        </div>

      </footer>

      <figure id='scroll-indicator'>|</figure>

    </React.Fragment>
  )
}

export default TemplateWrapper
